/** Channel size tiers by subscriber count, shared by QuickSearchDialog's legend/star
 *  badges and the influencer sidebar's subscriber range picker. */
export const CHANNEL_TIERS = {
  mega: {
    stars: 3, label: 'Mega', labelKo: '메가', desc: '1M+ subs', descKo: '100만명 이상',
    min: 1_000_000, max: null as number | null,
  },
  macro: {
    stars: 2, label: 'Macro', labelKo: '매크로', desc: '100K–1M subs', descKo: '10만~100만명',
    min: 100_000, max: 999_999,
  },
  micro: {
    stars: 1, label: 'Micro', labelKo: '마이크로', desc: '10K–100K subs', descKo: '1만~10만명',
    min: 10_000, max: 99_999,
  },
} as const;

export type ChannelTier = keyof typeof CHANNEL_TIERS;

export function getChannelTier(subs: number): ChannelTier | null {
  if (subs >= 1_000_000) return 'mega';
  if (subs >= 100_000) return 'macro';
  if (subs >= 10_000) return 'micro';
  return null;
}

/** "min~max" range string for a tier, matching the `subscriberCount` filter format ("min~max", open-ended when a side is empty). */
export function tierToRange(tier: ChannelTier): string {
  const { min, max } = CHANNEL_TIERS[tier];
  return `${min}~${max ?? ''}`;
}
